export default __webpack_public_path__ + "static/media/basement-main-category.ae1336f7.png";